import * as React from "react";
import useSendTelemetry from "./useSendTelemetry";
const withTelemetry = (Component) => function WrappedComponent(props) {
  const sendTelemetry = useSendTelemetry();
  return /* @__PURE__ */ React.createElement(Component, { ...props, sendTelemetry });
};
export default withTelemetry;
